  // export function formatDecimal(value, decimals = 3) {
  //   if (value !== '') {
  //     return parseFloat(value).toFixed(decimals);
  //   }
  //   return value;
  // }

  export function formatDecimal(value, decimals = 3) {
    if (value !== '') {
        let formattedValue = parseFloat(value);
        if (formattedValue < 0) {
            formattedValue = 0;
        }
        return formattedValue.toFixed(decimals);
    }
    return value;
}
